import { Phone, Mail } from "lucide-react";
import { SITE } from "@/lib/site";
import { useLocation } from "react-router-dom";

export default function MobileCallBar() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;

  return (
    <div
      data-testid="mobile-call-bar"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 grid grid-cols-2 border-t border-[#1A1A1A]/15 bg-white shadow-[0_-4px_16px_rgba(18,59,99,0.08)]"
    >
      <a
        href={SITE.phoneHref}
        className="flex items-center justify-center gap-2 py-3.5 text-sm font-bold uppercase tracking-wider text-white bg-[#F97316] active:bg-[#EA580C]"
        data-testid="mobile-call-todd"
      >
        <Phone className="w-4 h-4" /> Call Todd
      </a>
      <a
        href={SITE.emailHref}
        className="flex items-center justify-center gap-2 py-3.5 text-sm font-bold uppercase tracking-wider text-white bg-[#1A1A1A] active:bg-[#0A0A0A]"
        data-testid="mobile-email-todd"
      >
        <Mail className="w-4 h-4" /> Email
      </a>
    </div>
  );
}
